import _defineProperty from "@babel/runtime/helpers/defineProperty";
/*
 *                     NOTICE
 *            COPYRIGHT 2018 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { AbAccessDeniedDialog } from "abreact/incubator/ui/login/AbAccessDeniedDialog";
import { AbLogin } from "abreact/incubator/ui/login/AbLogin";
import { showSplashDialog } from "abreact/incubator/ui/login/AbSplashDialog";

/**
 * Helper class that exports 'default' react-based login and access denied functions that
 * can be directly used by the ServiceInitializer class.
 */

export class ReactUILoginHelper {
  constructor(portalLoginView) {
    _defineProperty(this, "portalLoginView", void 0);
    // convert methods to functions
    this.showAccessDeniedDlgFn = this.showAccessDeniedDlgFn.bind(this);
    this.showLoginFn = this.showLoginFn.bind(this);
    this.portalLoginView = portalLoginView;
  }

  /** React-based showAccessDeniedDlg that has already been converted to a function */
  showAccessDeniedDlgFn() {
    return AbAccessDeniedDialog.showAccessDeniedDialog();
  }

  /** React-based showLogin dialog that has already been converted to a function. */
  showLoginFn(loginProps = {}) {
    loginProps.portalLoginView ??= this.portalLoginView;
    return AbLogin.login(loginProps);
  }
  showSplashScreenFn() {
    return showSplashDialog();
  }
}
//# sourceMappingURL=ReactUILoginHelper.js.map
